interface BuildEconomicsUrlParams {
  integrationId: string
  monthStartUtc: string
  monthEndUtc: string
  /** `undefined` → all-mode (no `product_ids` in URL). `number[]` → filter by those ids. */
  productIds: number[] | undefined
  minimumOrderTotal: number
  freeShippingThreshold: number
  /** Default "product". "family" forces all-mode and aggregates by family_key. */
  groupBy?: "product" | "family"
}

/**
 * Pure helper building the product-economics GET URL so the contract
 * (omit `product_ids` in all-mode) can be tested without a React runtime.
 */
export function buildEconomicsUrl({
  integrationId,
  monthStartUtc,
  monthEndUtc,
  productIds,
  minimumOrderTotal,
  freeShippingThreshold,
  groupBy = "product",
}: BuildEconomicsUrlParams): string {
  const params = new URLSearchParams({
    integration_id: integrationId,
    month_start_utc: monthStartUtc,
    month_end_utc: monthEndUtc,
    minimum_order_total: String(minimumOrderTotal),
    free_shipping_threshold: String(freeShippingThreshold),
  })
  // Family mode ignores product_ids server-side (aggregation is over the
  // entire period). Omit the param to keep URLs short and explicit.
  if (groupBy === "family") {
    params.set("group_by", "family")
  } else if (productIds !== undefined) {
    params.set("product_ids", productIds.join(","))
  }
  return `/api/integrations/shopify/product-economics?${params.toString()}`
}
